import { memo, useCallback } from "react";

import CloseIcon from "@mui/icons-material/Close";
import { Paper, Step, StepLabel, Stepper, Typography } from "@mui/material";
import { t } from "i18next";

import { DriverRegistrationStep } from "src/shared/constants/driver";

import CompleteStep from "./registration-steps/complete-step";
import DocumentsStep from "./registration-steps/documents-step";
import ProfileStep from "./registration-steps/profile-step";

const steps = ["Profile", "Documents", "Complete"];
const paperStyle = {
  padding: 20,
  minWidth: "50%",
  margin: "20px auto",
};

const DriverRegistrationForm = (props) => {
  const { activeStep, isLoading, driverData, documentsData, driverActions, errors, onClose } = props;

  const handleSteps = useCallback(
    (step) => {
      const defaultProps = {
        activeStep,
        isLoading,
        driverActions,
      };

      switch (step) {
        case DriverRegistrationStep.Profile:
          return <ProfileStep errors={errors} {...defaultProps} />;
        case DriverRegistrationStep.Documents:
          return <DocumentsStep documentsData={documentsData} driverData={driverData} {...defaultProps} />;
        case DriverRegistrationStep.Complete:
          return <CompleteStep documentsData={documentsData} {...defaultProps} />;
        default:
          return <ProfileStep {...defaultProps} />;
      }
    },
    [activeStep, isLoading, errors, driverData, documentsData, driverActions],
  );

  return (
    <Paper elevation={7} style={paperStyle}>
      <CloseIcon onClick={onClose} />
      <Typography align="center" mb={5} variant="h4">
        {t("driver_registration")}
      </Typography>
      <Stepper activeStep={activeStep} alternativeLabel>
        {steps.map((label) => (
          <Step key={label}>
            <StepLabel>{t(label)}</StepLabel>
          </Step>
        ))}
      </Stepper>
      {handleSteps(activeStep)}
    </Paper>
  );
};

export default memo(DriverRegistrationForm);
